import { useState, useRef, useEffect } from "react"
import { formartMillarNumber } from "../../utils/stylesUtils"

function EditDemandTableCell({ demandValue, onChangeValue, newValue }) {

    const [_isEditing,      _setIsEditing       ] = useState(false)
    const [_value,          _setValue           ] = useState(demandValue?.wagons ?? 0)
    const [_originalValue,  _setOriginalValue   ] = useState(demandValue?.wagons ?? 0)

    const currentValue = newValue !== undefined ? newValue : demandValue?.wagons ?? 0

    const inputRef = useRef(null)

    useEffect(() => {
       
        _setValue(demandValue?.wagons ?? 0)
        _setOriginalValue(demandValue?.wagons ?? 0)

    }, [demandValue?.wagons])

    useEffect(() => {

        if (_isEditing && inputRef.current) {
            inputRef.current.focus()
            inputRef.current.select()
        }

    }, [_isEditing])

    const handleStartEditing = () => {

        _setOriginalValue(currentValue)
        _setValue(currentValue)
        _setIsEditing(true)

    }

    const handleConfirmEdit = () => {

        _setIsEditing(false)

        const numericValue = Number(_value)

        if (!Number.isFinite(numericValue)) {
            _setValue(_originalValue)
            return
        }

        if (numericValue !== _originalValue) {
            
            if (typeof onChangeValue === "function" && demandValue?.id) {
                onChangeValue(demandValue.id, numericValue)
            }
            else if (!demandValue?.id) {
                console.error("demandValue.id is undefined - no matching demand found")
            }
            else {
                console.error("onChangeValue is not a function")
            }

            _setOriginalValue(numericValue)
            _setValue(numericValue)
        }
    }

    const handleCancelEdit = () => {
        _setValue(_originalValue)
        _setIsEditing(false)
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault()
            handleConfirmEdit()
        }

        if (e.key === "Escape") {
            e.preventDefault()
            handleCancelEdit()
        }
    }

    return (
        <div
            onClick={() => {
                if (!_isEditing) handleStartEditing()
            }}
            className="w-full h-full cursor-pointer"
        >
            {_isEditing ? (
                <input
                    ref={inputRef}
                    type="number"
                    value={_value}
                    onChange={(e) => _setValue(e.target.value)}
                    onBlur={handleConfirmEdit}
                    onKeyDown={handleKeyDown}
                    className="
                    w-full
                    min-w-0
                    outline-none
                    text-right
                    bg-transparent
                    box-border
                "
            />
            ) : (
                <span>
                    {formartMillarNumber(_value)}
                </span>
            )}
        </div>
    )
}

export default EditDemandTableCell